import { useNavigation } from '@react-navigation/core';
import { Button, Headline3, theme } from 'aimo-ui';
import { InfoIcon } from 'components/icons/InfoIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SalesOrderReceipt } from 'screens/permit/SalesOrderReceiptClass';
import { StyledWrapper } from 'styles/ContainerStyles';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import {
  handlePermitNavigation,
  isPermitMissingVehicle,
  salesOrderExpiration,
} from 'utils/permitUtils';

const ActivateSalesOrderPermitButton: React.FC<{
  permit: UnifiedPermit;
  originalSalesOrderReceipt?: SalesOrderReceipt;
}> = ({ permit, originalSalesOrderReceipt }) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();

  const salesOrderReceipt =
    originalSalesOrderReceipt ?? new SalesOrderReceipt(permit);
  const isExpired = salesOrderExpiration(salesOrderReceipt)?.isExpired;
  const isProcessingPayment =
    salesOrderReceipt.orderStatus === 'WAITING_FOR_PAYMENT';
  const getButtonText = (): string => {
    if (isProcessingPayment) {
      return 'button.processingPayment';
    }

    if (salesOrderReceipt.isWaiting) {
      return 'permit.activatePermit';
    }

    if (isPermitMissingVehicle(permit?.registrationPlates)) {
      return 'permit.addVehicle';
    }

    return '';
  };

  if (isExpired) {
    return null;
  }

  return (
    <StyledWrapper mt={10}>
      <Button
        testID={'activate-permit-button'}
        buttonType="secondary"
        size="l"
        iconComponent={isProcessingPayment ? undefined : InfoIcon}
        loading={isProcessingPayment}
        accessibilityState={{ disabled: isProcessingPayment }}
        onPress={
          isProcessingPayment
            ? undefined
            : () => handlePermitNavigation(permit, navigate)
        }>
        <Headline3 color={theme.colors.white}>{t(getButtonText())}</Headline3>
      </Button>
    </StyledWrapper>
  );
};

export default ActivateSalesOrderPermitButton;
